export const INTERNAL_ROLES = [
  "sales",
  "customer_success",
  "consultant",
  "admin",
  "super_admin"
];

export const CUSTOMER_ROLES = [
  "owner",
  "sustainability_manager",
  "contributor",
  "reviewer",
  "auditor",
  "preparer",
  "approver"
];

export const PLAN_KEYS = {
  STARTER: "starter",
  PRO: "pro",
  ENTERPRISE: "enterprise"
};

export const FEATURE_KEYS = {
  REPORTING: "reporting",
  AI_DRAFTING: "ai_drafting",
  MATERIALITY: "materiality",
  INTELLIGENT_DOCUMENTS: "intelligent_documents",
  AI_DOCUMENT_SUMMARY: "ai_document_summary",
  DOUBLE_MATERIALITY: "double_materiality",
  ESRS_GAP_ANALYSIS: "esrs_gap_analysis",
  AI_ADVISORY_REPORTS: "ai_advisory_reports",
  CRM: "crm",
  REVENUE_INTELLIGENCE: "revenue_intelligence"
};

export const PLAN_FEATURES = {
  starter: [
    FEATURE_KEYS.REPORTING,
    FEATURE_KEYS.AI_DRAFTING
  ],

  pro: [
    FEATURE_KEYS.REPORTING,
    FEATURE_KEYS.AI_DRAFTING,
    FEATURE_KEYS.MATERIALITY,
    FEATURE_KEYS.INTELLIGENT_DOCUMENTS,
    FEATURE_KEYS.AI_DOCUMENT_SUMMARY,
    FEATURE_KEYS.DOUBLE_MATERIALITY
  ],

  enterprise: [
    FEATURE_KEYS.REPORTING,
    FEATURE_KEYS.AI_DRAFTING,
    FEATURE_KEYS.MATERIALITY,
    FEATURE_KEYS.INTELLIGENT_DOCUMENTS,
    FEATURE_KEYS.AI_DOCUMENT_SUMMARY,
    FEATURE_KEYS.DOUBLE_MATERIALITY,
    FEATURE_KEYS.ESRS_GAP_ANALYSIS,
    FEATURE_KEYS.AI_ADVISORY_REPORTS
  ]
};

export function hasFeature(plan, featureKey) {
  const normalizedPlan = String(plan || "").toLowerCase();

  return Boolean(
    PLAN_FEATURES[normalizedPlan] &&
      PLAN_FEATURES[normalizedPlan].includes(featureKey)
  );
}

export function isInternalRole(role) {
  return INTERNAL_ROLES.includes(String(role || "").toLowerCase());
}

export function isCustomerRole(role) {
  return CUSTOMER_ROLES.includes(String(role || "").toLowerCase());
}